import CardProjectFiche from "./CardProjectFiche";

const CardPause = ({ pauses = [] }) => {
	return (
		<CardProjectFiche title="Bitácora de tareas pausadas">
			<div className="h-[239px] md:h-[520px] overflow-y-scroll scroll-project-details text-[12px] flex flex-col gap-2">
				<div className="w-full grid grid-cols-[80px_80px_calc(100%-200px)] gap-4 font-bold">
					<p>Pausas</p>
					<p>Reanudación</p>
					<p>Motivo</p>
				</div>
				<div className="h-[2px] w-full bg-gray-200"></div>
				{pauses.map((pause, index) => (
					<div key={`${index}-pause`} className="w-full grid grid-cols-[80px_80px_calc(100%-200px)] h-[20px] gap-4">
						<p>{pause.init}</p>
						<p>{pause.close}</p>
						<p>{pause.reason}</p>
					</div>
				))}
			</div>
		</CardProjectFiche>
	);
};

export default CardPause;
